import { createSlice } from "@reduxjs/toolkit";

// Normalizes an id candidate for identity comparisons across this slice:
// "12" and 12 must be treated as the same lot. Anything that isn't a real
// number (undefined/null/""/non-numeric) normalizes to null, which never
// matches - update()/removeL() treat that as a no-op instead of throwing,
// since a stale/partial cache-invalidation payload for an entity that isn't
// cached yet (or a caller with no try/catch) must never crash the app.
const toId = (value) => {
    if (value === undefined || value === null || value === '') return null;
    const n = Number(value);
    return Number.isNaN(n) ? null : n;
};

export const lotsSlice = createSlice({
    name: 'lots',
    initialState: [],
    reducers: {
        emptyLots: state => {
            return []
        },
        setLots: (state, action) => {
            if (Array.isArray(action?.payload)) {
                return action.payload
            }
        },
        add: (state, action) => {
            // TO DO: to be faster, add just the new element, but there are missing data (id, actual_quantity) that must be given by the backend
            // action.payload.actual_quantity = action.payload.quantity;
            return [...state, action.payload]
            // return []
        },
        // Upsert: merges into the existing lot (payload wins over stale
        // fields, existing fields not present in payload are preserved), or
        // inserts it if it isn't cached yet. Never throws.
        update: (state, action) => {
            const id = toId(action?.payload?.id);
            if (id === null) return state;

            const foundedIndex = state.findIndex((lot) => toId(lot.id) === id);
            if (foundedIndex !== -1) {
                state[foundedIndex] = { ...state[foundedIndex], ...action.payload };
            } else {
                state.push(action.payload);
            }
        },
        // Idempotent remove: absent entity or invalid id is a no-op, never throws.
        removeL: (state, action) => {
            const id = toId(action?.payload?.id);
            if (id === null) return state;
            return state.filter((lot) => toId(lot.id) !== id);
        }
    }
});

export const {
    setLots, 
    emptyLots,
    update,
    removeL,
    add
} = lotsSlice.actions;

export default lotsSlice.reducer